import { React, fetchApi } from '@gasbuddy/react';
import { Button, Form, Table, Message, List, Icon } from 'semantic-ui-react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Feature } from '../features';

export class AddUser extends React.Component {
  state = {
    features: [Feature.Wex, Feature.Bank, Feature.ConfirmMd, Feature.PastShipDate],
    accounts: [],
  }

  createUser = async (e) => {
    e.preventDefault();
    const { features, accounts } = this.state;
    this.setState({ loading: true });
    const { status, body, error } = await fetchApi({
      url: '/devtools/account/create',
      body: { features },
    });
    if (status === 201) {
      this.setState({
        accounts: [...accounts, body],
        loading: false,
      });
    } else {
      this.setState({ error: error || body, loading: false });
    }
  }

  featureBox(label, feature) {
    const { features } = this.state;
    return (
      <Form.Checkbox
        label={label}
        defaultChecked={features.includes(feature)}
        onChange={(d, v) => {
          if (v.checked) {
            if (!features.includes(feature)) {
              this.setState({ features: [...features, feature] });
            }
          } else if (features.includes(feature)) {
            this.setState({ features: features.filter(f => f !== feature) });
          }
        }}
      />
    );
  }

  render() {
    const { loading, error, accounts, copied } = this.state;
    return (
      <Form loading={loading} error={!!error}>
        {error
          && (
          <Message error>
            Unable to create account:
            <pre>{JSON.stringify(error, null, '\t')}</pre>
          </Message>
          )
        }
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell colSpan={2}>Account Creation</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            <Table.Row style={{ verticalAlign: 'top' }}>
              <Table.Cell>
                <h3>Bank</h3>
                <Form.Group grouped>
                  {this.featureBox('Add a Bank Account', 'bank')}
                  {this.featureBox('Use IAV for Bank Account', 'iav')}
                  {this.featureBox('Verify Bank Account', 'verify-bank')}
                </Form.Group>
              </Table.Cell>
              <Table.Cell>
                <h3>Payment Card</h3>
                {this.featureBox('Add a Wex Card', Feature.Wex)}
              </Table.Cell>
              <Table.Cell>
                <h3>Ship Date</h3>
                {this.featureBox('Add Past Ship Date', Feature.PastShipDate)}
              </Table.Cell>
            </Table.Row>
          </Table.Body>
          <Table.Footer>
            <Table.Row>
              <Table.Cell colSpan={2}>
                <Button onClick={this.createUser}>Create New Account</Button>
                {accounts.length > 0
                  && (
                  <List divided>
                    {accounts.map(a => (
                      <List.Item>
                        <List.Icon name="user" verticalAlign="middle" />
                        <List.Content>
                          <List.Header>
                            <a
                              target="_blank"
                              rel="noopener noreferrer"
                              href={`/identity/users/${a.account_id}`}
                            >
                              {a.email}
                            </a>
                            <CopyToClipboard
                              text={a.email}
                              onCopy={() => this.setState({ copied: a.email })}
                              options={{ format: 'text/plain' }}
                            >
                              <Button toggle icon active={copied === a.email} labelPosition="left">
                                <Icon name={copied === a.email ? 'clipboard check' : 'clipboard'} />
                                {copied === a.email ? 'Copied to clipboard!' : 'Copy'}
                              </Button>
                            </CopyToClipboard>

                          </List.Header>
                          <List.Description>
                            <div>
                              Account Id:
                              {a.account_id}
                            </div>
                            <div>
                              Password: password12
                              <CopyToClipboard
                                text="password12"
                                onCopy={() => this.setState({ copied: true })}
                                options={{ format: 'text/plain' }}
                              >
                                <Button toggle icon active={copied === a.email} labelPosition="left">
                                  <Icon name={copied === true ? 'clipboard check' : 'clipboard'} />
                                  {copied === true ? 'Copied to clipboard!' : 'Copy'}
                                </Button>
                              </CopyToClipboard>
                            </div>
                            <div>{`Membername: ${a.membername}`}</div>
                            {a.bank && (
                            <div>
                              Bank:
                              {a.bank.friendly_name}
                            </div>
                            )}
                            {a.wex && (
                            <div>
                              Wex:
                              {a.wex.friendly_name}
                            </div>
                            )}
                          </List.Description>
                        </List.Content>
                      </List.Item>
                    ))}
                  </List>
                  )
                }
              </Table.Cell>
            </Table.Row>
          </Table.Footer>
        </Table>
      </Form>
    );
  }
}
